import { gql, useQuery } from "@apollo/client"
import { Paper, Card, Grid, Button, Typography, Collapse, Accordion, AccordionSummary, AccordionDetails, Box } from "@mui/material"
import { Description, ExpandMore } from "@mui/icons-material"
import { Header, HeaderActionType, TableStandard, useManageModal } from "ui"
import { useEffect, useState } from "react"
import AdventureStatsTable from "./components/AdventureStasTable"

const GET_SESSION_ADVENTURE_STATS = gql(`query getAllSessionForGlobal{
  allSessionForGlobal{
    id
    adventure{
      id
      name
    }
    totalTimeSpent
    activeTimeInSurvey
    type 
    category
    language
    status
  }
}`)
// export type AdventureStats = {
//     adventureId: string | null,
//     name: string | null,
// }
export type SessionAdventureStats = {
    id: string | null,
    adventure: string | null,
    adventureId: string | null,
    totalTimeSpent: string | null,
    activeTimeInSurvey: string | null,
    type: string | null,
    category: string | null,
    language: string | null
    status: string | null
}

const GlobalOverViewPage = ({ onBack }: { onBack: () => void }) => {
    const { loading, data } = useQuery(GET_SESSION_ADVENTURE_STATS)
    const [tweenScreenTableState, setTweenScreenTableState] = useState<SessionAdventureStats[]>([]);
    const [tScreenTableState, setTScreenTableState] = useState<SessionAdventureStats[]>([]);
    const { openModal, closeModal } = useManageModal()
    useEffect(() => {
        if (!data) return;
        let tScreenSessions: SessionAdventureStats[] = []
        let tweenScreenData: SessionAdventureStats[] = []
        data?.allSessionForGlobal.forEach((session: any) => {
            const mapped: SessionAdventureStats = {
                id: session.id,
                adventure: session?.adventure?.name ?? null,
                adventureId: session?.adventure?.id ?? null,
                totalTimeSpent: session.totalTimeSpent,
                activeTimeInSurvey: session.activeTimeInSurvey,
                type: session.type,
                category: session.category,
                language: session.language,
                status: session.status
            };

            // adjust this rule if needed
            if (session.type === "TweenScreen") {
                tweenScreenData.push(mapped);
            } else {
                tScreenSessions.push(mapped);
            }
        })
        setTScreenTableState(tScreenSessions)
        setTweenScreenTableState(tweenScreenData)
        // console.log(temp)
    }, [data])

    const getNewestGlobalReport = async () => {
        const response = await fetch(`${window.__env.API_URL}/api/file/newest-global-report`)
        if (response.status == 404) {

        } else if (response.status >= 500) {
            openModal({ type: "GENERAL_ERROR" })
        } else {
            const fileId = await response.json();
            closeModal()
            const link = document.createElement('a');
            link.href = `${window.__env.API_URL}/api/file/download/client/weekly-reports/${fileId.fileId}`
            link.target = "_blank"
            const linkHandler = () => {
                setTimeout(() => {
                    link.removeEventListener('click', linkHandler);
                    document.body.removeChild(link);
                }, 300);
            }
            link.addEventListener('click', linkHandler);
            document.body.appendChild(link);
            link.click()
        }
    }
    const headerActions: HeaderActionType[] = [
        {
            name: "Weekly Report",
            icon: <Description />,
            action: getNewestGlobalReport,
        }
    ]
    const [accordionState, setAccordionState] = useState(false)
    const switchState = () => {
        if (accordionState) {
            setAccordionState(false)
        } else {
            setAccordionState(true)
        }
    }
    return (
        <>
            {/* <Paper component="div"> */}
            <Grid container spacing={2} sx={{ marginTop: "16px" }}>
                <Grid size={12}>
                    <Card elevation={4} style={{ width: "100%", padding: "16px", height: "auto" }}>
                        <Header disableDivider title="Complete Usage Report" onBack={onBack} headerActions={headerActions} />
                    </Card >
                </Grid>
                <Grid size={12}>
                    <Paper style={{ marginBottom: ".5rem", padding: "16px" }}>
                        <Typography variant="h5">General Statistics</Typography>
                        <Typography>Adventures Selected, Local vs Remote, Average Time Spent in Session, Active Time in Session, English vs Spanish</Typography>
                    </Paper>
                    <Grid container>
                        <Grid size={6}>
                            <Paper>
                                <Accordion expanded={accordionState} onChange={switchState}>
                                    <AccordionSummary expandIcon={<ExpandMore />}  >
                                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                                            <Typography variant="h5">Tween Screen</Typography>
                                        </Box>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ border: "none", borderTop: "2px solid rgb(209 213 219)" }}>
                                        <Grid container spacing={1}>
                                            <AdventureStatsTable sessionTypeData={tweenScreenTableState} />
                                        </Grid>
                                        <Typography>My Stats</Typography>

                                    </AccordionDetails>
                                </Accordion>

                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >

        </>
    )
}
export default GlobalOverViewPage